import React from 'react';
import { I } from '../icons-ds';
import { Avatar } from '../ui';
import { SidebarItem } from './SidebarItem';
import { FolderTreeItem } from './FolderTreeItem';
import type { Folder } from '../lib/types';

export type SidebarProps = {
  active?: string;
  onNavigate: (target: string) => void;
  accent?: string;
  folders: Folder[];
  favoriteCount?: number;
  userName?: string;
  userEmail?: string;
};

export function Sidebar({
  active,
  onNavigate,
  accent = 'var(--accent)',
  folders,
  favoriteCount,
  userName = 'Samuel Edusa',
  userEmail = 'samuel.edusa@gmail.com',
}: SidebarProps) {
  const items = [
    { id: 'home', icon: <I.search size={18} />, label: 'Search' },
    { id: 'favorites', icon: <I.starFill size={18} />, label: 'Favorites', count: favoriteCount },
    { id: 'glossary', icon: <I.bookmark size={18} />, label: 'Glossary' },
  ];

  return (
    <aside
      style={{
        width: 248, height: '100%',
        background: 'var(--bg-grouped)',
        borderRight: '1px solid var(--line-divider)',
        display: 'flex', flexDirection: 'column',
        padding: '16px 12px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 8px 18px' }}>
        <I.logo size={28} />
        <div>
          <div style={{ fontWeight: 700, letterSpacing: '-0.3px', fontSize: 15 }}>DotPhrase</div>
          <div className="t-caption1" style={{ color: 'var(--fg-tertiary)', marginTop: -2 }}>
            Clinical library
          </div>
        </div>
      </div>

      <nav style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {items.map((it) => (
          <SidebarItem
            key={it.id}
            active={active === it.id}
            onClick={() => onNavigate(it.id)}
            icon={it.icon}
            count={it.count}
          >
            {it.label}
          </SidebarItem>
        ))}
      </nav>

      <div style={{ marginTop: 24, padding: '0 8px 6px' }}>
        <span
          style={{
            fontSize: 11, fontWeight: 600, letterSpacing: '0.6px',
            color: 'var(--fg-tertiary)', textTransform: 'uppercase',
          }}
        >
          Folders
        </span>
      </div>
      <div
        style={{
          display: 'flex', flexDirection: 'column', gap: 1,
          overflow: 'auto', paddingRight: 4, marginRight: -4,
        }}
      >
        {folders.map((f) => (
          <FolderTreeItem key={f.id} folder={f} active={active} onNavigate={onNavigate} />
        ))}
      </div>

      <div style={{ flex: 1 }} />

      <div
        style={{
          display: 'flex', flexDirection: 'column', gap: 2,
          paddingTop: 12, borderTop: '1px solid var(--line-divider)',
        }}
      >
        <SidebarItem
          icon={<I.settings size={18} />}
          onClick={() => onNavigate('settings')}
          active={active === 'settings'}
        >
          Settings
        </SidebarItem>
        <SidebarItem
          icon={<Avatar name={userName} size={22} accent={accent} />}
          onClick={() => onNavigate('account')}
          active={active === 'account'}
          subtitle={userEmail}
        >
          {userName}
        </SidebarItem>
      </div>
    </aside>
  );
}

export default Sidebar;
